import React, { useState } from "react";
import DatePicker from "react-flatpickr";
import { InputGroup, InputGroupText } from "reactstrap";

export const ClearableDatePicker = ({ value, onChange, placeholder, options, onClear }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div 
      className="clearable-datepicker-wrapper"
      style={{ position: "relative", width: "100%" }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <DatePicker
        className="form-control"
        placeholder={placeholder}
        value={value || ""}
        onChange={onChange}
        options={options}
        style={{ paddingRight: value && isHovered ? "30px" : "10px" }}
      />
      {value && isHovered && (
        <div
          onClick={() => {
            if (onClear) onClear();
          }}
          style={{
            position: "absolute",
            right: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            cursor: "pointer",
            color: "#FF5F00",
            fontSize: "16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "white",
            borderRadius: "50%",
            width: "20px",
            height: "20px",
            zIndex: 10
          }}
        >
          <i className="bx bx-x-circle" style={{ fontSize: "18px" }} />
        </div>
      )}
    </div>
  );
};
